module.exports = __webpack_public_path__ + "img/zhga-2.3e3191c9.png";